import n from "react";
import { useTranslation as d } from "react-i18next";
import s from "./loadMore.module.scss.js";
function c({
  borderColor: e = "#eee",
  hasNextPage: o,
  isLoading: t,
  isFetching: r,
  fetchNextPage: a
}) {
  const {
    t: l
  } = d();
  return o ? /* @__PURE__ */ n.createElement(
    "button",
    {
      "data-testid": "load-more",
      disabled: t || r,
      type: "button",
      style: {
        "--borderColor": e
      },
      className: s.loadMore,
      onClick: () => a()
    },
    l("loadMore")
  ) : null;
}
export {
  c as LoadMore
};
//# sourceMappingURL=LoadMore.js.map
